<template>
    <div class="pos_container_panel" style="padding-left: 2rem; width: 90%">
      <Loading :loading="submitLoading" />
      <!--查询条件-->
      <el-form :inline="true" :model="searchForm" style="margin-left: 6rem; padding-top: 2rem">
        <el-row>
          <el-col :span="8">
            <el-form-item label="酒店集团Code">
              <el-input v-model="searchForm.code" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="酒店集团名称">
              <el-input v-model="searchForm.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div style="float: right">
              <el-button type="warning" class="harpIDbtn" @click="searchHotel()">搜索</el-button>
              <el-button type="warning" class="harpIDbtn" style="margin-left: 3rem" @click="addHotel()">新增</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!--table-->
      <el-table :data="tableData" border style="width: 90%; margin-top: 30px; margin-left: 100px" :default-sort = "{prop: 'score', order: 'descending'}" @sort-change="sortChange">
        <el-table-column prop="fxHotelID" label="FX酒店ID" align="center"></el-table-column>
        <el-table-column prop="hotelName.zh-CN" label="酒店名称-中文" align="center"></el-table-column>
        <el-table-column prop="hotelName.en" label="酒店名称-英文" align="center"></el-table-column>
        <el-table-column prop="score" label="分数" align="center" sortable = 'custom'></el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template #default="scope">
            <el-button @click="handleChange(scope.row)" type="text" size="small">修改</el-button>
            <el-button type="text" size="small" @click.prevent="deleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="paginationsty"
        background
        @current-change="handleCurrentChange"
        v-model:current-page="currentPage1"
        :page-size="searchForm.pageSize"
        layout="total, prev, pager, next"
        :total="searchForm.total"
      />
      <!--新增 dialog-->
      <el-dialog title="新增" v-model="dialogFormVisible" @close="closeaddDialog('form')" >
        <el-divider class="title-divider"></el-divider>
        <el-form :model="form" :rules="hotelRules" ref="form">
          <el-form-item label="酒店名称:" :label-width="formLabelWidth" prop="hotelName">
            <el-input v-model="form.hotelName" @click="showHotelNamePop" autocomplete="off" class= "inputStyle"></el-input>
          </el-form-item>
          <el-form-item label="分值(0-10):" :label-width="formLabelWidth" prop="score">
            <el-input type="number" v-model="form.score" autocomplete="off" class= "inputStyle"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" @click="dataSave()">保存</el-button>
            <el-button @click="cancel()">取 消</el-button>
          </div>
        </template>
      </el-dialog>
      <!--修改 dialog-->
      <el-dialog title="修改" v-model="changeHotelScoreFlag" >
        <el-divider class="title-divider"></el-divider>
        <el-form :model="changeForm" :rules="hotelRules" ref="changeForm">
          <el-form-item label="酒店名称-中文:" :label-width="formLabelWidth">
            <el-input v-model="changeForm.CName" :disabled="true" autocomplete="off" class= "inputStyle"></el-input>
          </el-form-item>
          <el-form-item label="酒店名称-英文:" :label-width="formLabelWidth">
            <el-input v-model="changeForm.EName" :disabled="true" autocomplete="off" class= "inputStyle"></el-input>
          </el-form-item>
          <el-form-item label="分值(0-10):" :label-width="formLabelWidth" prop="score">
            <el-input type="number" v-model="changeForm.score" autocomplete="off" class= "inputStyle"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" @click="changeSave()">保存</el-button>
            <el-button @click="cancel()">取 消</el-button>
          </div>
        </template>
      </el-dialog>
      <!--删除 dialog-->
      <el-dialog v-model="deletedialogVisible" width="30rem" >
        <span>确定要删除吗？</span>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="primary" @click="confirmDelete">确 定</el-button>
            <el-button @click="cancelDelete">取 消</el-button>
          </span>
        </template>
      </el-dialog>
      <!-- start 酒店名称 dialog -->
      <el-dialog width="90rem" class="dialog-one" v-model="hotelDialogInfo.dialogHotel" :show-close="false">
        <el-tabs v-model="hotelDialogInfo.hotelActiveName" type="card">
          <el-tab-pane :label="$t('MANUAL.HOTELIST')" name="first">
            <el-row>
              <el-col :span="4"></el-col>
              <el-col :span="6" class="search-input">
                <div>{{ $t("MANUAL.SEACHHOTELNAME") }}</div>
                <el-input v-model="hotelDialogInfo.searchHotelName"></el-input>
              </el-col>
              <el-col :span="4"></el-col>
              <el-col :span="6" class="search-btn" @click="getHotelList(1)">
                <el-button style="margin-left:4.5rem">{{ $t("USERDIALOG.BTNSEARCH") }}</el-button>
              </el-col>
            </el-row>
            <div>
              <Loading :loading="hotelloading" />
              <el-table :data="hotelDialogInfo.hotelData">
                <el-table-column prop='name.zh-CN' :label="$t('MANUAL.HOTELNAMECN')" width="170"></el-table-column>
                <el-table-column prop="name.en" :label="$t('MANUAL.HOTELNAMEEN')" width="170"></el-table-column>
                <el-table-column prop="starRating" :label="$t('MANUAL.SEACHSTARRATING')" width="100"></el-table-column>
                <el-table-column prop="contactNumber" :label="$t('MANUAL.CONTACTTEL')" width="135"></el-table-column>
                <el-table-column prop="address.zh-CN" :label="$t('MANUAL.HOTELADDRESS')"></el-table-column>
                <el-table-column width="100" :label="$t('USERDIALOG.OPERATION')">
                  <template #default="scope">
                    <div class="select-btn" @click="selectHotel(scope.row)">
                      {{ $t("USERDIALOG.SELECT") }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-row style="float: right; margin: 2%">
              <el-pagination background layout="prev, pager, next" :total="hotelDialogInfo.pagination.total" :page-size="hotelDialogInfo.pagination.pageSize" :current-page="hotelDialogInfo.pagination.currentPage" @current-change="pageChange_hotelDialog">
              </el-pagination>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
      <!-- end 酒店名称 dialog -->
      <ConfirmBoxs
        :centerDialogVisible="confirmFlag"
        :confirmMsg="confirmMsg"
        :icon="confirmIcon"
        @setConfirmFlag="setConfirmFlag"
      ></ConfirmBoxs>
    </div>
  </template>
  
  <script>
  import {
    hotelScoreList,
    hotelScoreSave,
    hotelScoreDelete,
    getHotelLookup,
  } from "@/api/shoppingData";
  import Loading from "@/components/Loading.vue";
  import ConfirmBoxs from "@/components/confirmBoxs.vue";
  export default {
    name: "HBEHotelScore",
    components: {
      ConfirmBoxs,
      Loading,
    },
    data() {
      return {
        deletedialogVisible: false,
        deleteFlag: false,
        deleteparams: {},
        confirmFlag: false,
        currentPage1: 1,
        form: {
          hotelName: "",
          score: "",
          fxHotelID: 0,
        },
        changeForm: {
          id: 0,
          fxHotelID: 0,
          CName: "",
          EName: "",
          score: "",
        },
        //新增dialog
        confirmIcon: "",
        confirmMsg: "",
        dialogFormVisible: false,
        changeHotelScoreFlag: false,
        formLabelWidth: "150px",
        tableData: [],
        searchForm: {
          name: "",
          total: 0,
          code: "",
          pageSize:15,
        },
        submitLoading: false,
        hotelloading: false,
        hotelDialogInfo: {
          dialogHotel: false,
          hotelActiveName: "first",
          searchHotelName: "",
          hotelData: [],
          pagination: {
            total: 0, //总数
            pageSize: 5,
            currentPage: 1
          }, //分页信息
        },
        sort: 0,//降序 0 升序1 默认降序
      };
    },
    mounted() {
      this.searchHotel();
    },
    computed: {
      hotelRules() {
        return {
          hotelName: [{ required: true, message: this.$t("MANUAL.VALIDATEHOTELNAME"), trigger: ["blur", "change"]},],
          score: [{ pattern: /^[0-9]$|^10$/, message:'请输入0到10的分数', trigger: ["blur", "change"], }],
        }
      },
    },
    methods: {
      closeaddDialog(formRule) {
        //重置表单的验证状态和值
        this.$refs[formRule].resetFields();
      },
      handleCurrentChange(val) {
        this.searchHotel(val);
      },
      addHotel() {
        this.dialogFormVisible = true;
      },
      //新增保存
      async dataSave() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            let saveParams = {
              fxHotelID: this.form.fxHotelID,
              score: this.form.score,
              createdBy: this.$objBaseInfo.loginID,
            };
            hotelScoreSave(saveParams)
              .then((res) => {
                if (res.code == 200) {
                  if (!res.status) {
                    this.confirmFlag = true;
                    this.deleteFlag = false;
                    this.confirmMsg = res.message;
                    this.currentPage1 = 1;
                  } else {
                    this.confirmFlag = true;
                    this.deleteFlag = false;
                    this.confirmMsg = "新增成功";
                    this.dialogFormVisible = false;
                    this.searchHotel();
                    this.currentPage1 = 1;
                  }
                } else {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = res.message; //res.message
                  this.currentPage1 = 1;
                }
              })
              .catch(function (error) {
                console.log("新增失败", error.objError);
                this.searchHotel();
              });
          }
        });
      },
      // 修改保存
      changeSave() {
        this.$refs["changeForm"].validate((valid) => {
          if(valid){
            let saveParams = {
              id: this.changeForm.id,
              fxHotelID: this.changeForm.fxHotelID,
              score: this.changeForm.score,
              updateBy: this.$objBaseInfo.loginID,
            };
            hotelScoreSave(saveParams)
            .then((res) => {
                if (res.code == 200) {
                  if (!res.status) {
                    this.confirmFlag = true;
                    this.changeHotelScoreFlag = false;
                    this.confirmMsg = res.message;
                    this.currentPage1 = 1;
                  } else {
                    this.confirmFlag = true;
                    this.changeHotelScoreFlag = false;
                    this.confirmMsg = "修改成功";
                    this.searchHotel();
                    this.currentPage1 = 1;
                  }
                } else {
                  this.confirmFlag = true;
                  this.changeHotelScoreFlag = false;
                  this.confirmMsg = res.message; //res.message
                  this.currentPage1 = 1;
                }
              })
              .catch(function (error) {
                console.log("修改失败", error.objError);
                this.searchHotel();
              });
            }
        })
      },
      //修改button
      handleChange(row) {
        this.changeHotelScoreFlag = true;
        this.changeForm.id = row.id;
        this.changeForm.fxHotelID = row.fxHotelID;
        this.changeForm.CName = row.hotelName["zh-CN"];
        this.changeForm.EName = row.hotelName.en;
        this.changeForm.score = row.score;
      },
      //取消button
      cancel() {
        this.dialogFormVisible = false;
        this.changeHotelScoreFlag = false;
      },
      //删除dialog
      cancelDelete() {
        this.deletedialogVisible = false;
      },
      //删除
      deleteRow(row) {
        this.deletedialogVisible = true;
        this.deleteparams = {
          params: {
            id: row.id,
          },
        };
      },
      async confirmDelete() {
        this.deletedialogVisible = false;
        hotelScoreDelete(this.deleteparams)
          .then((res) => {
            if (res.code == 200) {
              this.confirmFlag = true;
              this.confirmMsg = "删除成功";
              this.searchHotel();
              this.currentPage1 = 1;
            } else {
              this.confirmFlag = true;
              this.confirmMsg = "删除失败";
            }
          })
          .catch(() => {
            console.log("删除请求失败");
          });
      },
      //搜索button
      async searchHotel(int) {
        this.submitLoading = true;
        let searchparams = {
          params: {
            hotelName: this.searchForm.name,
            hotelId: this.searchForm.code,
            sort: this.sort,
            page: int ? int : 1,
            per_page: this.searchForm.pageSize,
          },
        };
        await hotelScoreList(searchparams)
          .then((res) => {
            console.log(res);
            this.submitLoading = false;
            this.tableData = res.data.list;
            this.searchForm.total = res.data.total;
          })
          .catch(function (error) {
            this.submitLoading = false;
            console.log("请求失败", error.objError);
          });
      },
      setConfirmFlag(value) {
        this.confirmFlag = value;
      },
      // 弹出酒店名窗口方法
      showHotelNamePop() {
        this.hotelDialogInfo.dialogHotel = true;
        this.getHotelList(1);
      },
      //#region 操作酒店列表方法

      //获取酒店列表信息
      async getHotelList(currPage) {
        this.hotelloading = true;
        let hotelParam = {
          params: {
            page: currPage,
            per_page: 5,
            hotelName: this.hotelDialogInfo.searchHotelName,
          },
        };
        let that = this;
        await getHotelLookup(hotelParam)
          .then((res) => {
            if (res.data) {
              that.hotelDialogInfo.pagination.total = res.data.pagination.totalItemCount; //总数
              that.hotelDialogInfo.pagination.pageSize = hotelParam.params.per_page;
              that.hotelDialogInfo.pagination.currentPage = res.data.pagination.page;
              that.hotelDialogInfo.hotelData = res.data.items;
            }
            this.hotelloading = false;
          })
          .catch(function (error) {
            this.hotelloading = false;
            console.log("酒店信息 请求失败", error.objError);
          });
      },
      //酒店列表分页切换
      pageChange_hotelDialog(currPage) {
        this.getHotelList(currPage);
      },
      //选择酒店
      selectHotel(item) {
        this.hotelDialogInfo.dialogHotel = false;
        this.form.fxHotelID = item.id;
        this.form.hotelName = item.name["zh-CN"];
      },
      sortChange(column){
        this.sort = column.order == "ascending" ? 1 : 0;
        this.searchHotel();
      },
      //#endregion
    },
  };
  </script>
  
  <style scoped>
  .paginationsty {
    float: right;
    margin: 1rem 0;
  }
  
  .pos_container_panel {
    padding: 0 16rem 4rem;
  }
  
  .harpIDbtn {
    width: 10rem;
    height: 3rem;
    padding: 0 !important;
    font-size: 1rem !important;
  }
  .inputStyle {
    width: 58%; 
    margin-left: 85px;
  }
  .title-divider {
    margin-bottom: 3rem;
    margin-top: -1rem;
    height: 2px;
    background-color: #FF694B;
  }
  ::v-deep .dialog-one .el-dialog__header, ::v-deep .dialog-one .el-tabs__active-bar {
    display: none;
  }

  ::v-deep .dialog-one .el-dialog__body {
    padding: 0px;
  }
  .search-input {
    margin-left: 10%;
  }
  .search-btn {
    margin: 2% 5%;
  }
  .search-btn button {
      padding: 7px 20px;
      border: 1px solid #FF694B;;
      color: #FF694B;
  }
  .select-btn {
    color: #FF694B;
    cursor: pointer;
  }
  </style>
  